import checkRolesExist from "./check-roles-exist.js";
import checkNotLastUser from "./check-not-last-user.js";

export default {
	checkRolesExist,
	checkNotLastUser,
};
